import { render } from "./default.vue?vue&type=template&id=70107fa0&bindings={}"
import script from "./default.vue?vue&type=script&lang=ts"
export * from "./default.vue?vue&type=script&lang=ts"
script.render = render

export default script